export default __webpack_public_path__ + "static/media/wb.de88601c.png";